module.exports = "/_next/static/images/app-intro-device-velieve@2x-min-1a5a5781d7d7cdb1ba6b4829f43eefba.png";